import SurveyTemplatePanel from './surveyTemplatePanel.container'

export default SurveyTemplatePanel